import { HttpHeaders,HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services';
import { environment } from '../../../environments/environment';
import { ISearchPageThemeUserAssignmentUpdate, IUpdateThemeColsAssignList } from '../models';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

@Injectable({
  providedIn: 'root'
})
export class SearchThemeUsersAssignService {
    constructor(private http: HttpClient,
        private apiService: ApiService) { }
    public getUsersList(userId:number):Observable<any> {
        return this.apiService.get(`SearchPageThemeUserAssignment/GetUsersList?userId=${userId}`)
    }
    public getAllSearchPageThemeUsers(searchPageThemeUsersSearchParam:IGlobalSearchParam):Observable<any> {
        return this.apiService.post(`SearchPageThemeUserAssignment/SearchSearchPageThemeUserAssignment`,searchPageThemeUsersSearchParam)
      }
      public updateSearchPageThemeUserAssignment(searchPageThemeUserAssignment:ISearchPageThemeUserAssignmentUpdate):Observable<any> {
        return this.apiService.post(`SearchPageThemeUserAssignment/UpdateSearchPageThemeUserAssignment`,searchPageThemeUserAssignment)
      }
      public getCheckUserAssignmentForTheme(themeId:number):Observable<any> {
        return this.apiService.get(`SearchPageThemeUserAssignment/CheckUserAssignmentForTheme?themeId=${themeId}`)
    }
    public getThemeNamesfromUserId(userId:number,searchPageId:number):Observable<any> {
        return this.apiService.get(`SearchPageThemeUserAssignment/GetThemePageBasedOnUserId?userId=${userId}&searchPageId=${searchPageId}`)
    }
    public getUserAssign(userAssignId:number,themeId:number):Observable<any> {
      return this.apiService.get(`SearchPageThemeUserAssignment/GetUserAssignEdit?userAssignId=${userAssignId}&themeId=${themeId}`)
  }
  public GetSelectedUsers(userProfileIds:string): Observable<any> {
    return this.apiService.get(`SearchPageThemeUserAssignment/GetSelectedUsers?userProfileIds=${userProfileIds}`);
   }
    public ExportSearchPageThemeUsersAssign(searchPageThemeSearchParam:IGlobalSearchParam):Observable<any> {
      return this.http.post(`${environment.apiRoot}SearchPageThemeUserAssignment/ExportSearchPageThemeUsersAssign`, searchPageThemeSearchParam,
      {  
          responseType: 'blob',
          observe: 'response'
       });
    }
}